import React, { useState, useEffect,useRef } from 'react';
import { Menu, X, Phone, Mail, Clock, Wrench,Scissors, Home, AlertCircle, Zap, Star, Award, Shield, Calculator, Search,Truck, ArrowLeft, Package, CloudRain, ChevronRight, ArrowRight, Users, Building, CheckCircle, TrendingUp, ChevronLeft, Grid, List, ShoppingCart, HardHat, PaintBucket, Droplets, Thermometer, Layers, Send, Calendar, DollarSign, Bath, Target, Hammer, Handshake, Cpu, Microscope, Quote, MapPin} from 'lucide-react';

import { Trabajo, Producto, Servicio, PhoneNumber } from '../types';
import SearchBar from './SearchBar';

// ==================== NAVBAR PROFESIONAL ====================
interface NavbarProps {
  currentPage: string;
  navigateToPage: (page: string) => void;
  isMenuOpen: boolean;
  setIsMenuOpen: (isOpen: boolean) => void;
  scrolled: boolean;
}

export default function Navbar({ currentPage, navigateToPage, isMenuOpen, setIsMenuOpen, scrolled }: NavbarProps) {
  const navItems = [
    { id: 'home', label: 'Inicio' },
    { id: 'servicios', label: 'Servicios' },
    { id: 'proyectos', label: 'Proyectos' },
    { id: 'productos', label: 'Productos' },
    { id: 'contacto', label: 'Contacto' }
  ];

  // Enlaces reales <a href> para que Google pueda rastrear las páginas internas,
  // pero con navegación SPA (sin recargar) gracias a preventDefault.
  const hrefFor = (id: string) => (id === 'home' ? '/' : `/${id}`);
  const handleNavClick = (e: React.MouseEvent, id: string) => {
    e.preventDefault();
    navigateToPage(id);
  };

  return (
    <nav className={`fixed w-full top-0 z-50 transition-all duration-300 ${
      scrolled ? 'glass shadow-lg py-4' : 'bg-white py-6'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <a
            href="/"
            className="flex items-center cursor-pointer"
            onClick={(e) => handleNavClick(e, 'home')}
            aria-label="José Luis Construcciones - Inicio"
        >
          <img
            src="/logo_transparent.png"
            alt="José Luis Construcciones - Reformas en General Multiservicios"
            className="h-12 w-auto md:h-14 object-contain hover:opacity-90 transition-opacity"
          />
        </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={hrefFor(item.id)}
                onClick={(e) => handleNavClick(e, item.id)}
                className={`font-medium transition-all duration-200 focus:outline-none focus:text-blue-600 ${
                  currentPage === item.id
                    ? 'text-blue-600 border-b-2 border-blue-600'
                    : 'text-gray-700 hover:text-blue-600'
                }`}
                aria-current={currentPage === item.id ? 'page' : undefined}
              >
                {item.label}
              </a>
            ))}
          </div>

          {/* Search Bar y CTA */}
          <div className="hidden md:flex items-center space-x-4">
            <SearchBar navigateToPage={navigateToPage} />
            <a
              href="/contacto"
              onClick={(e) => handleNavClick(e, 'contacto')}
              className="bg-blue-600 text-white px-6 py-2.5 rounded-lg font-medium hover:bg-blue-700 shadow-lg hover:shadow-xl transition-all whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2">
              Presupuesto Gratis
            </a>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden p-2 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded-lg"
            aria-label={isMenuOpen ? "Cerrar menú de navegación" : "Abrir menú de navegación"}
            aria-expanded={isMenuOpen}
          >
            {isMenuOpen ? <X className="h-6 w-6" aria-hidden="true" /> : <Menu className="h-6 w-6" aria-hidden="true" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="md:hidden bg-white border-t">
          <div className="px-4 py-4 space-y-2">
            {/* Buscador móvil */}
            <div className="mb-4">
              <SearchBar navigateToPage={navigateToPage} />
            </div>
            {navItems.map((item) => (
              <a
                key={item.id}
                href={hrefFor(item.id)}
                onClick={(e) => handleNavClick(e, item.id)}
                className={`block w-full text-left px-4 py-2 rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                  currentPage === item.id
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
                aria-current={currentPage === item.id ? 'page' : undefined}
              >
                {item.label}
              </a>
            ))}
            <a
              href="/contacto"
              onClick={(e) => handleNavClick(e, 'contacto')}
              className="block w-full text-center bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg font-medium focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Presupuesto Gratis
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}
